"use strict"
import axios from "axios";
import { getPastDateAsString } from "./DateService";
import { getAuthHeaders } from "./UserTokenService";

const base_route = `premia/tba/spd_records`

export const getSpdRecords = async () => {
  const response = await axios.get(base_route, getAuthHeaders());
  return response;
}

export const getSpdRecord = async (sys_id) => {
  const response = await axios.get(`${base_route}/${sys_id}`, getAuthHeaders());
  return response;
}

export const getPassedSpdRecords = async (dto) => {
  // default to 3 days ago
  if (dto.start_date === undefined || dto.start_date === null) dto = {...dto, start_date : getPastDateAsString(3)};
  if (dto.end_date === undefined || dto.end_date === null) dto = {...dto, end_date : getPastDateAsString(0)};

  
  const urlParams = new URLSearchParams(dto).toString();

  const url = `${base_route}/history?${urlParams}`;

  const response = await axios.get(url, getAuthHeaders());

  return response;
}

export const createSpdRecord = async (spd_record_dto) => {
  const response = await axios.post(`${base_route}`, spd_record_dto, getAuthHeaders());

  return response;
}
